import { ObjectFieldsChecker } from "../../../../../../../tools/ObjectFieldsChecker";
import { MarketplaceBuildingInfoDto } from "../../../../../../networking/data/responses/marketplace/buildings/MarketplaceBuildingInfoDto";

export class MarketplaceBuildingInfo {
    public readonly imageUrl: string;
    public readonly level: number;
    public readonly address: string;
    public readonly zipCode: string;
    public readonly borough: string;
    public readonly city: string;
    public readonly initialVisitCostInCoins: number;
    public readonly floors: number;
    public readonly costPerSqft: number;
    public readonly sqft: number;
    public readonly piggyMultiplier?: number;
    public readonly supportCoupon: boolean;
    public readonly canBePurchased: boolean;
    public readonly tokenId?: string;
    public readonly tokensForPurchasing?: string; 

    public constructor(buildingInfoDto: MarketplaceBuildingInfoDto) {
        ObjectFieldsChecker.throwIfInvalidFields(buildingInfoDto, [
            "imageUrl",
            "imageUrl",
            "level",
            "address",
            "zipCode",
            "borough",
            "city",
            "sqft",
            "initialVisitCostInCoins",
            "floors",
            "sqft",
            "supportCoupon",
            "canBePurchased"
        ]);
        this.imageUrl = buildingInfoDto.imageUrl;
        this.level = buildingInfoDto.level;
        this.address = buildingInfoDto.address;
        this.zipCode = buildingInfoDto.zipCode;
        this.borough = buildingInfoDto.borough;
        this.city = buildingInfoDto.city;
        this.initialVisitCostInCoins = buildingInfoDto.initialVisitCostInCoins;
        this.floors = buildingInfoDto.floors;
        this.costPerSqft = buildingInfoDto.costPerSqft;
        this.sqft = buildingInfoDto.sqft;
        this.piggyMultiplier = buildingInfoDto.piggyMultiplier ?? 0;
        this.supportCoupon = buildingInfoDto.supportCoupon;
        this.canBePurchased = buildingInfoDto.canBePurchased;
        this.tokenId = buildingInfoDto.tokenId;
        this.tokensForPurchasing = buildingInfoDto.tokensForPurchasing;
    }
}
